module.exports = __webpack_public_path__ + "img/avatar-11.11b2098d.jpg";